import * as React from 'react'
import { observer } from 'mobx-react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
  StickyViewHeaderExtras,
} from 'components/StickyViewHeader'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'
import { ViewHeading } from 'components/ViewHeading'
import ProfileViewModel from '../ProfileViewModel'
import AvatarSelector from 'components/AvatarSelector'

interface ProfileHeaderProps {
  viewTitle: string
  scrollOffset: ScrollOffsetInterpolation
  vm: ProfileViewModel
  tabBar?: React.ReactNode
  saveButton?: React.ReactNode
}

export default observer(function ProfileHeader({
  scrollOffset,
  viewTitle,
  vm,
  saveButton,
  tabBar,
}: ProfileHeaderProps) {
  const member = vm.member
  return (
    <StickyViewHeader scrollOffset={scrollOffset} tabBar={tabBar}>
      <StickyViewHeaderMain>
        <ViewHeading
          visual={<ProfileAvatar vm={vm} />}
          primaryText={viewTitle}
          secondaryText={member.displayName}
        />
      </StickyViewHeaderMain>
      <StickyViewHeaderSpacer />
      <StickyViewHeaderExtras>{saveButton}</StickyViewHeaderExtras>
    </StickyViewHeader>
  )
})

interface ProfileAvatarProps {
  vm: ProfileViewModel
}

const ProfileAvatar = observer(function ProfileAvatar({
  vm,
}: ProfileAvatarProps) {
  return (
    <AvatarSelector
      size={48}
      subject={vm.member}
      isUploading={vm.uploadNewAvatar.pending}
      onSelectNewFile={vm.uploadNewAvatar}
    />
  )
})
